let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aONrf")).then(() => parcelRequire('4CdMl'));